import React from "react";
import { AiSummaryMetric } from "./aiSummaryTypes";
import classes from "./AiSummary.module.css";

type Props = {
  metric: AiSummaryMetric;
};

const formatMeasurementMonth = (value: string): string => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    year: "numeric",
  }).format(date);
};

const AiSummaryMeasurementTable = ({ metric }: Props) => {
  const measurements = (metric.measurements ?? []).slice(0, 2);

  if (!metric.showMeasurementTable || measurements.length < 2) {
    return null;
  }

  const unit = metric.unit || (metric.scorePercent !== undefined ? "%" : "");
  const formatValue = (value: number) =>
    `${value}${unit ? `${unit === "%" ? "" : " "}${unit}` : ""}`;

  return (
    <div className={classes.measurementTable}>
      <table aria-label={`${metric.name} measurement history`}>
        <thead>
          <tr>
            {measurements.map((measurement, index) => (
              <th scope="col" key={`${measurement.dateCreated}-${index}`}>
                {formatMeasurementMonth(measurement.dateCreated)}
              </th>
            ))}
            <th scope="col">Interpretation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {measurements.map((measurement, index) => (
              <td key={`${measurement.dateCreated}-${index}`}>
                {formatValue(measurement.value)}
              </td>
            ))}
            <td>
              <span className={classes.interpretationLabel}>
                {metric.interpretation || "Not available"}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AiSummaryMeasurementTable;
